import React from "react";
import TextField from "@material-ui/core/TextField";

export const TextLabel = props => (
  <TextField
    margin="normal"
    style={{ width: "100%" }}
    variant="outlined"
    {...props}
    InputProps={{
      readOnly: true
    }}
  />
);
